import { React } from "react";
const Reporte2 = ({ nombre, mdstatus, eseditable }) => {
    return(
        <div className=" w-full h-full">
        <iframe className=" w-full h-full border-0"
          src="https://lookerstudio.google.com/embed/reporting/867fb73c-0a08-449c-8349-8f63044dc626/page/GHRBE" 
        allowfullscreen sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe></div>
    )
}
export default Reporte2;